export default "__VITE_ASSET__CwP_I7VM__"